'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'react-bootstrap/lib/Panel';
import { apiString } from '../actions/api';

const imageStyle = {
  maxWidth: '100%',
  margin: 5,
  display: 'block',
  float: 'left',
};

const imageComponent = ({ imageB64, videoLink }) => {
  return (
    imageB64 || videoLink ?
      <Panel bsStyle="warning" collapsible="true">
        <Panel.Heading>
          <Panel.Title toggle>
            Image
          </Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {
              videoLink ?
                <video controls runat="server" width="100%" height="100%">
                  <source src={apiString.media.getStreamVideo(videoLink)}
                    type="video/mp4"
                  />
                  Your browser does not support HTML5 video.
                </video> :
                <img src={imageB64} style={imageStyle} />
            }
          </Panel.Body>
        </Panel.Collapse>
      </Panel> :
      <Panel>
        <Panel.Heading>
          <Panel.Title>
            No Image Found
          </Panel.Title>
        </Panel.Heading>
      </Panel>
  );
};

imageComponent.propTypes = {
  imageB64: PropTypes.string,
  videoLink: PropTypes.string,
};

export default imageComponent;


// WEBPACK FOOTER //
// src/Components/ImageComponent.jsx